import { configureProvider } from "./provider";
import { useSyncExternalStore } from "react";
import { ADS_OFF, PublicAdsConfigSchema, type PublicAdsConfig } from "@serendiptv/contracts";
let current: PublicAdsConfig = ADS_OFF;
let inFlight = false;
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | undefined;
async function refresh() {
  if (inFlight || document.visibilityState === "hidden") return;
  inFlight = true;
  let next = ADS_OFF;
  try {
    const response = await fetch("/v1/public-config", { credentials: "same-origin", cache: "no-store", signal: AbortSignal.timeout(8000) });
    if (response.ok) next = PublicAdsConfigSchema.parse((await response.json()).ads);
  } catch { /* Config unavailable means ads off; playback is independent. */ }
  finally { inFlight = false; }
  configureProvider(next);
  if (JSON.stringify(next) !== JSON.stringify(current)) { current = next; for (const listener of listeners) listener(); }
}
const onVisible = () => { void refresh(); };
function subscribe(listener: () => void) {
  listeners.add(listener);
  if (listeners.size === 1) {
    void refresh(); timer = setInterval(() => void refresh(), 45_000);
    document.addEventListener("visibilitychange", onVisible);
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) { clearInterval(timer); document.removeEventListener("visibilitychange", onVisible); }
  };
}
export function usePublicAdsConfig() { return useSyncExternalStore(subscribe, () => current); }
